import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "../../i18n/useTranslation";

interface SwipeScreenProps {
  show: boolean;
}

export function SwipeScreen({ show }: SwipeScreenProps) {
  const { t } = useTranslation();
  return (
    <AnimatePresence>
      {show ? (
        <motion.div
          initial={{ x: "-100%", opacity: 0 }}
          exit={{ x: "-100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          className="absolute inset-0 z-40 flex flex-col items-center justify-center text-2xl font-bold divide-y divide-white md:text-6xl "
        >
          <motion.p
            initial={{ x: "100%", opacity: 0 }}
            exit={{ x: "-100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.5, ease: "linear" }}
            className="flex items-center justify-center w-full p-4 bg-slate-900/70"
          >
            VIRTUALLY SPORTS
          </motion.p>

          <motion.p
            initial={{ x: "-100%", opacity: 0 }}
            exit={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.8, ease: "linear" }}
            className="flex items-center justify-center w-full p-4 bg-slate-900/70"
          >
            {t("swipe-screen")}
          </motion.p>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
